import React, { Component, useState } from 'react'
import { UploadFile } from "../../api/support"
import { Alert, FormControl, Form, Modal } from 'react-bootstrap'
import StatusMessage from "../../lib/statusmessage"
import MySupportEditor from './my-support-editor';
import * as support from '../../api/support'
import { withRouter, Link } from 'react-router-dom'
import LoadingModal from "./loading-modal"

class MyNewCase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Alert: null,
            Alerts: [],
            UserID: this.props.UserID,
            NewCaseTitle: "",
            NewCaseEnvSettingsProduct: -1,
            NewCaseEnvSettingsPlatform: -1,
            NewCaseEnvSettingsControl: -1,
            NewCaseEnvSettingsVersion: null,
            EnvSettings: null,
            InEU: this.props.InEU 
        }
        this.onAcceptedFiles = this.onAcceptedFiles.bind(this);
        this.submitNewCase = this.submitNewCase.bind(this);
        this.newCaseTitleChange = this.newCaseTitleChange.bind(this);
        this.getEnironmentSettings = this.getEnironmentSettings.bind(this);
        this.selectedProductChanged = this.selectedProductChanged.bind(this);
        this.selectedPlatformChanged = this.selectedPlatformChanged.bind(this);
        this.selectedControlChanged = this.selectedControlChanged.bind(this);
        this.inputVersionChanged = this.inputVersionChanged.bind(this);
        this.Editor = React.createRef();
    }

    async componentWillMount() {
        this.setState({ Loading: true });
        await this.getEnironmentSettings();
        this.setState({ Loading: false });

    }

    onAcceptedFiles = async (files) => {

        files.forEach(async (file) => {
            let uploadFile = new File([file], `${this.state.UserID}&#47;${file.name}`)
            let upload = await UploadFile(uploadFile);

            this.setState({
                Alert: new StatusMessage({
                    Status: "success",
                    Message: `${upload.msg}`,
                })
            })


        })
    }

    getEnironmentSettings = async () => {
        let _settings = await support.GetCaseSettings();
        this.setState({
            EnvSettings: _settings
        })
    }

    selectedProductChanged = ({ target }) => {

        this.setState({
            NewCaseEnvSettingsProduct: target.options[target.selectedIndex].value,
            NewCaseEnvSettingsPlatform: -1,
            NewCaseEnvSettingsControl: -1
        })
    }
    selectedPlatformChanged = ({ target }) => {

        this.setState({
            NewCaseEnvSettingsPlatform: target.options[target.selectedIndex].value,
            NewCaseEnvSettingsControl: -1
        })
    }
    selectedControlChanged = ({ target }) => {
        this.setState({ NewCaseEnvSettingsControl: target.options[target.selectedIndex].value })
    }
    inputVersionChanged = ({ target }) => {
        this.setState({ NewCaseEnvSettingsVersion: target.value })
    }


    clearAlerts() {
        this.setState({ Alert: null, Alerts: [] });
    }

    newCaseTitleChange({ target }) {
        this.setState({ NewCaseTitle: target.value });
    }
    submitNewCase = async (body, attachments) => {
        this.clearAlerts();
        let _alerts = [];
        if (!this.state.NewCaseTitle == null || this.state.NewCaseTitle == "") {
            _alerts.push({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `Please provide a title for the case`,
                })
            })
        }
        if (this.state.NewCaseEnvSettingsProduct == -1) {
            _alerts.push({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `Please select a Product`,
                })
            })
        }
        if (body == null || typeof body == "undefined") {
            _alerts.push({
                Alert: new StatusMessage({
                    Status: "danger",
                    Message: `Please enter your new case below`,
                })
            })
        }

        if (_alerts.length == 0) {
            try {
                this.setState({ Loading: true });
                let data = {
                    "Title": this.state.NewCaseTitle,
                    "Description": body,
                    "Attachments": attachments.map(att => { return att.attachment }) || [],
                    "ProductData": {
                        "Platform": this.state.NewCaseEnvSettingsPlatform,
                        "Product": this.state.NewCaseEnvSettingsProduct,
                        "Control": this.state.NewCaseEnvSettingsControl,
                        "Version": this.state.NewCaseEnvSettingsVersion
                    }
                }

                let newcase = await support.AddNewCase(data);

                return this.props.history.push(`/case/${newcase.caseid}`);

            } catch (ex) {
            } finally {
                this.setState({ Loading: false });
            }

        } else {
            this.setState({ Alerts: _alerts })
        }

    }

    render() {
        return (
            <div className={`my-support-section my-support-new-case-wrap`}>

                <div className={`row my-support-new-case-meta`}>
                    <div className={`col-md-9 my-support-new-case-meta-inner`}>
                        <h2>My New Case</h2>
                    </div>
                    <div className={`col-md-3 my-support-new-case-meta-inner`}>
                        <Link to={`/`} className={`btn gc-btn btn-primary my-support-case-back`}>Back to My Cases</Link>
                    </div>
                </div>


                {this.state.Alert &&
                    <Alert variant={this.state.Alert.Status}>
                        {this.state.Alert.Message}
                    </Alert>
                }

                {this.state.InEU  &&
                    <Alert variant={`info`}>
                        Support cases for your geographic region must be submitted through our official European office. Please visit <a href="//www.mescius.eu">www.mescius.eu</a> to continue. <a href='/about/eu-office-information'>More Information</a>
                    </Alert>
                }
                {this.state.Alerts.length > 0 &&
                    (() => {
                        let alerts = this.state.Alerts.map((alert) => {
                            return (
                                <Alert variant={alert.Alert.Status}>
                                    {alert.Alert.Message}
                                </Alert>
                            )
                        });
                        return <div>{alerts}</div>
                    })()

                }





                <Form className={`my-support-case-new-case-intake`}>
                    <FormControl type="text" placeholder="Case Title" value={this.state.NewCaseTitle} onChange={this.newCaseTitleChange} />

                    <Form.Group>
                        <Form.Label>Product:</Form.Label>
                        <FormControl as={`select`} onChange={this.selectedProductChanged} value={this.state.NewCaseEnvSettingsProduct}>
                            <option value={-1}>Select one...</option>
                            {this.state.EnvSettings &&
                                (() => {
                                    let options = this.state.EnvSettings.ProductSettings.Products.sort((x, y) => {
                                        return x.OrderNumber - y.OrderNumber;
                                    })
                                        .map(product => {
                                            return <option value={product.Value}>{product.Name}</option>
                                        });
                                    return options;
                                })()

                            }
                        </FormControl>
                        {
                            this.state.NewCaseEnvSettingsProduct != -1 &&
                            <div>
                                <Form.Label>Platform:</Form.Label>
                                <FormControl as={`select`} onChange={this.selectedPlatformChanged} value={this.state.NewCaseEnvSettingsPlatform}>
                                    <option value={-1}>Select one...</option>
                                    {this.state.EnvSettings &&
                                        (() => {
                                            let options = this.state.EnvSettings.ProductSettings.Products.filter(x => { return x.Value === this.state.NewCaseEnvSettingsProduct })[0].Platforms.sort((x, y) => {
                                                return x.OrderNumber - y.OrderNumber;
                                            })
                                                .map(product => {
                                                    return <option value={product.Value} >{product.Name}</option>
                                                });
                                            return options;
                                        })()

                                    }
                                </FormControl>
                            </div>
                        }
                        {
                            this.state.NewCaseEnvSettingsPlatform != -1 &&
                            <div>
                                <Form.Label>Control:</Form.Label>
                                <FormControl as={`select`} onChange={this.selectedControlChanged} value={this.state.NewCaseEnvSettingsControl}>
                                    <option value={-1}>Select one...</option>
                                    {this.state.EnvSettings &&
                                        (() => {
                                            let options = this.state.EnvSettings.ProductSettings.Products.filter(x => { return x.Value === this.state.NewCaseEnvSettingsProduct })[0]
                                                .Platforms.filter(x => x.Value === this.state.NewCaseEnvSettingsPlatform)[0].Controls.sort((x, y) => {
                                                    return x.OrderNumber - y.OrderNumber;
                                                })
                                                .map(product => {
                                                    return <option value={product.Value} >{product.Name}</option>
                                                });
                                            return options;
                                        })()

                                    }
                                </FormControl>
                                <Form.Label>Version:</Form.Label>
                                <FormControl maxLength={50} onChange={this.inputVersionChanged} value={this.state.NewCaseEnvSettingsVersion}>
                                </FormControl>
                            </div>
                        }
                    </Form.Group>
                </Form>
                <MySupportEditor onSubmit={this.submitNewCase} onSubmitAttempt={this.submitNewCase} disabledSubmit={
                    this.state.NewCaseTitle == "" ||
                    this.state.NewCaseEnvSettingsProduct == -1 ||
                    this.state.Loading
                } />
                <LoadingModal display={this.state.Loading} />

            </div>

        )
    }
}

export default withRouter(MyNewCase);